import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Footer from "./components/Layout/Footer";
import Navbar from "./components/Layout/Navbar";
import Home from "./pages/Home";
import ScrollToTop from "./ScrollToTop";

const Contact = lazy(() => import("./pages/Contact"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const Mookoob = lazy(() => import("./pages/Mookoob"));
const Lizzy = lazy(() => import("./pages/Lizzy"));
const Elmis = lazy(() => import("./pages/Elmis"));
const StatisticsDashboard = lazy(() => import("./pages/StatisticsDashboard"));
const MyCareer = lazy(() => import("./pages/MyCareer"));
const Space44 = lazy(() => import("./pages/Space44"));

function App() {
  return (
    <div>
      <Navbar />
      <ScrollToTop>
        <Suspense fallback={<div className="min-h-screen bg-N0" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/space44" element={<Space44 />} />
            <Route path="/project/my-career" element={<MyCareer />} />
            <Route path="/project/mookoob" element={<Mookoob />} />
            <Route path="/project/lizzy" element={<Lizzy />} />
            <Route path="/project/lmis" element={<Elmis />} />
            <Route
              path="/project/statistics-dashboard"
              element={<StatisticsDashboard />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/confirm" element={<ThankYou />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
      <Footer />
    </div>
  );
}

export default App;
